import React from "react";

export const Europa = () => {
  return (
    <div>
      <div
        id={"europa"}
        style={{
          frameborder: "0",
          width: "100%",
          height: "470px",
        }}
      ></div>
    </div>
  );
};
